<div>
  <p-accordion value="">
    <p-accordion-panel value="1">
      <p-accordion-header class="darkHeader" style="{'background-color': '#7b95a3 !important'}">
        <div>
          Filters:
          <span class="mr-4">{{filterDisplay}}</span>
          <span class="float-right">{{totalRecords}} packages</span>
        </div>
      </p-accordion-header>
      <p-accordion-content>
        <div class="grid p-ai-center vertical-container">
          <div class="col-9">
            <div class="grid">
              <div class="col-12">
                <p-select [options]="includeExceptionsOptions" inputSize="40em" [(ngModel)]="includeExceptionsValue" (onChange)="exceptionFilterChange($event)" optionLabel="label" class="mt-2 w-56" />
              </div>
              <div class="col-12">
                <p-select [options]="includeRejectionsOptions" inputSize="40em" [(ngModel)]="includeRejectionsValue" (onChange)="rejectionFilterChange($event)" optionLabel="label" class="w-56" />
              </div>
              <div class="col-12">
                <p-select [options]="includeDateFilterOptions" inputSize="40em" [(ngModel)]="includeDateFilterValue" (onChange)="dateFilterChange($event)" optionLabel="label" class="w-56" />
                <span [hidden]="includeDateFilterValue.value == 0">
                  <!---->
                  <p-datepicker id="beginReceivedDate" name="beginReceivedDate" [(ngModel)]="filter.BeginReceivedDate" [style]="{'width':'120px'}" [inputStyle]="{'width':'120px'}" class="margin-left-10"></p-datepicker>
                  -
                  <p-datepicker id="endReceivedDate" name="endReceivedDate" [(ngModel)]="filter.EndReceivedDate" [style]="{'width':'120px'}" [inputStyle]="{'width':'120px'}"></p-datepicker>
                </span>
              </div>
            </div>
          </div>
          <div class="col-3">
            <p-button class="pull-right rounded margin-top-20" (click)="applyFilter()" label="  Filter" icon="far fa-filter" iconPos="left"></p-button>
          </div>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</div>

<p-table #packagelist [columns]="cols" [value]="packages" [lazy]="true" (onLazyLoad)="loadPackagesLazy($event)" [paginator]="true"
         [rows]="20" [totalRecords]="totalRecords" [loading]="loading">
  <ng-template pTemplate="caption" [style]="{'height':'30px !important', 'background-color': 'rgb(123, 149, 163) !important'}">
    <div style="height: 30px; width: 100%; background-color: rgb(123, 149, 163)">
      <span class="float-left">Package List</span>
      <div class="float-right">
        <input pInputText type="text" (keypress)="handleSearchKey($event, packagelist)" placeholder="Search" [style]="{'margin-right':'15px'}" [ngModel]="searchTerm" />
        <a (click)="loadPackagesLazy(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
        <a *hasClaim="'Resolve_Edit'" [hidden]="processingExceptions " (click)="attemptToResolveRequisitionExceptions()" class="text-white iconbutton" title="Resolve Exceptions"><i class="fal fa-laptop-medical"></i> </a>
        <span [hidden]="!processingExceptions" class="text-white iconbutton"><i class="fas fa-spinner fa-pulse"></i></span>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width:50px">&nbsp;</th>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>

  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td>
        <a style="cursor:pointer" (click)="rowData['showDetail'] = !rowData['showDetail'];"><i class="fa fa-eye"></i></a>
      </td>
      <td *ngFor="let col of columns" [ngSwitch]="col.field">
        <span *ngSwitchDefault>{{rowData[col.field]}}</span>
        <span *ngSwitchCase="'DeliveredDate'">
          {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
        </span>
        <span *ngSwitchCase="'ReceivedDate'">
          {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
        </span>
        <span *ngSwitchCase="'OpenedDate'">
          {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
        </span>
        <span *ngSwitchCase="'CompletedDate'">
          {{rowData[col.field] | date:'MM/dd/yyyy HH:mm'}}
        </span>

      </td>
    </tr>
    <tr *ngIf="rowData['showDetail'] == true">
      <td colspan="11" style="background-color: lightgray; padding: 15px">
        <app-receiving-package searchTerm="{{searchTerm}}" packageId="{{rowData['Id']}}"></app-receiving-package>
      </td>
    </tr>
  </ng-template>
</p-table>
<p-toast></p-toast>
